// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2qwk0","label":"LabeledBox_label__3q5tf"};